import { useState } from "react";
import dynamic from "next/dynamic";
import { Transition } from "@headlessui/react";

const LoadingReview = dynamic(() => import("./loading-review"));

const LoadingTransition = ({ hasData, children, loading = false }) => {
  // Control the visibility of the loading review component,
  // so that it doesn't flicker when the loading state changes.
  const [showLoadingReview, setShowLoadingReview] = useState(true);

  return (
    <div className="bg-gradient-to-r from-light-purple to-bittersweet p-[2px] rounded-lg">
      <div className="min-w-[236px] min-h-[56px] w-full flex items-center justify-center group bg-white rounded-lg">
        <Transition
          show={loading && !hasData}
          enter="transition-all duration-700"
          enterFrom="opacity-0"
          enterTo="opacity-100 flex items-center justify-center"
          leave="transition-all duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => {
            setShowLoadingReview(false);
          }}
        >
          <LoadingReview />
        </Transition>
        <Transition
          show={!loading && !showLoadingReview && hasData}
          enter="transition-all ease-in-out duration-1000"
          enterFrom="opacity-0"
          enterTo="opacity-100 flex items-center justify-center"
        >
          {children}
        </Transition>
      </div>
    </div>
  );
};

export default LoadingTransition;
